module.exports = __webpack_public_path__ + "img/user4.c2ea7cc3.svg";